import { LanguageCode } from "../common/enums";
export default {
  [LanguageCode.en]: {
    "系统异常，请稍后重试": "System error, please try again later",
    "网络异常，稍后重试": "Network error, please try again later",
  },
  [LanguageCode.vi]: {
    "系统异常，请稍后重试": "Lỗi hệ thống, vui lòng thử lại sau",
    "网络异常，稍后重试": "Lỗi mạng, vui lòng thử lại sau",
  },
  [LanguageCode.in]: {
    "系统异常，请稍后重试": "Kendala pada sistem, coba kembali nanti",
    "网络异常，稍后重试": "Jaringan internet bermasalah, coba kembali nanti",
  },
  [LanguageCode.ms]: {
    "系统异常，请稍后重试": "System error, please try again later",
    "网络异常，稍后重试": "Network error, please try again later",
  },
  [LanguageCode.zh]: {
    "系统异常，请稍后重试": "系统异常，请稍后重试",
    "网络异常，稍后重试": "网络异常，稍后重试",
  },
  [LanguageCode.de]: {
    "系统异常，请稍后重试": "System error, please try again later",
    "网络异常，稍后重试": "Network error, please try again later",
  },
  [LanguageCode.es]: {
    "系统异常，请稍后重试": "System error, please try again later",
    "网络异常，稍后重试": "Network error, please try again later",
  },
};
